import _ from 'lodash';
import { ACTIVITY_TYPES } from '../constants/activities.constants';

const _activityToType = (activity) => {
  if (activity.action === 'status change') {
    return ACTIVITY_TYPES.STATUS;
  }

  return ACTIVITY_TYPES.CHANGE;
};

const _transformActivity = (activity) => {
  return {
    ...activity,
    type: _activityToType(activity)
  };
};

export const getActivitiesData = (data) => {
  const sorted = _.sortBy(
    data?.filter((d) => !!d.id),
    (a) => a.createdAt
  );
  // console.log(sorted);
  // return sorted?.map(_transformActivity);
  return sorted?.map(_transformActivity);
};

export const getCommentsData = (data) => {
  return _.sortBy(data, (a) => a.createdAt);
};

export const getCategory = (activity) => {
  // TODO for now no category as it has no added value
  return '';
  // return activity?.domainObject || 'Algemeen';
  // switch (activity.domainObject) {
  //   case 'Request clarification':
  //     return 'Vraagverheldering';
  // case ACTIVITY_TYPES.COMMENT:
  //   return '';

  // default:
  //   return 'Algemeen';
  // }
};

export const activityUserToInitials = (user) => {
  return `${user?.firstName?.[0] ?? ''}${user?.lastName?.[0] ?? ''}`;
};
